import { numberInputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

var _a = createMultiStyleConfigHelpers(numberInputAnatomy.keys), definePartsStyle = _a.definePartsStyle, defineMultiStyleConfig = _a.defineMultiStyleConfig;
var numberInput = definePartsStyle({
    field: {
        border: "1px solid",
        borderColor: "neutrals.600",
        borderRadius: 'md',
        fontSize: '16px',
        color: 'neutrals.900',
        '& ~ .chakra-input__right-element': {
            color: 'neutrals.600',
        },
        '& ~ .chakra-input__left-element': {
            color: 'neutrals.600',
        },
        _hover: {
            border: '1.5px solid',
            borderColor: 'neutrals.600',
            color: 'neutrals.600'
        },
        _focusVisible: {
            border: '2px solid',
            borderColor: "focused",
            color: "neutrals.900",
            boxShadow: '0px 2px 8px 0px rgba(162, 150, 118, 0.20)',
        },
        _disabled: {
            border: '1px solid',
            borderColor: 'neutrals.400',
            color: 'neutrals.600',
            _hover: {
                border: '1px solid',
                borderColor: 'neutrals.400',
            }
        },
    },
});
var sizes = defineStyle({
    xs: {
        field: {
            width: '100%',
            height: '36px',
            px: 3,
            py: 2
        }
    },
    sm: {
        field: {
            width: '100%',
            height: '36px',
            px: 3,
            py: 2
        }
    },
    lg: {
        field: {
            width: '100%',
            height: '48px',
            px: 3,
            py: '14px'
        },
    }
});
var numberInputTheme = defineMultiStyleConfig({
    defaultProps: {
        variant: 'numberInput',
        size: 'xs'
    },
    variants: { numberInput: numberInput },
    sizes: sizes
});

export { numberInputTheme };
//# sourceMappingURL=numberInput.js.map
